import * as React from "react";
const SvgIcDownload = props => <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M11 3.5v6h1.17L10 11.67 7.83 9.5H9v-6h2Zm2-2H7v6H3l7 7 7-7h-4v-6Zm4 15H3v2h14v-2Z" /></svg>;
export default SvgIcDownload;